import { forEach, map, findKey, findLastKey, findLastIndex } from 'lodash';
import { GET_ALL_USERS_DONE } from '../actions/constantsActions';

const initialState = {};

const usersReducer = (state = initialState, action) => {
  const { type, payload, id } = action;
  const newState = {};

  switch (type) {
    case GET_ALL_USERS_DONE:
      forEach(payload, (user) => {
        newState[user.id] = user;
      });

      return {
        ...state,
        ...newState
      };
    case 'ADD_ADMIN_RIGHTS':
      const adminRole = {
        ...state[id].roles,
        ...{ A9: { name: 'ROLE_ADMIN', active: true } }
      };
      return {
        ...state,
        [id]: {
          ...state[id],
          roles: adminRole
        }
      };
    case 'UPDATE_ADMIN_RIGHTS':
      const initialRoles = { ...state[id].roles };
      const index = findKey(initialRoles, {
        name: 'ROLE_ADMIN'
      });
      const newRole = !initialRoles[index].active;
      return {
        ...state,
        [id]: {
          ...state[id],
          initialRoles: {
            ...initialRoles,
            [index]: {
              ...initialRoles[index],
              active: newRole
            }
          }
        }
      };
    default:
      return state;
  }
};

export default usersReducer;
